import { ImageTemplate } from '@/models/imageSlot'
import TemplateImageOverlay from './TemplateImageOverlay'
import { useExampleImages } from '@/contexts/exampleImageContext'

interface TemplateImageWithExamplesProps {
  backgroundImage: string
  template: ImageTemplate
  className?: string
}

export default function TemplateImageWithExamples({
  backgroundImage,
  template,
  className = ''
}: TemplateImageWithExamplesProps) {
  const { exampleImages } = useExampleImages()

  const imageUrls = exampleImages.map(img => img.detail || img.file)

  return (
    <TemplateImageOverlay
      backgroundImage={backgroundImage}
      slots={template.slots}
      images={imageUrls}
      mask={template.mask}
      className={className}
    />
  )
}
